import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchBarcodeLocationComponent } from './search-barcode-location.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



@NgModule({
  declarations: [SearchBarcodeLocationComponent],
  exports: [SearchBarcodeLocationComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressSpinnerModule
  ]
})
export class SearchBarcodeLocationModule { }
